import { render, staticRenderFns } from "./AmbassadorsCard.vue?vue&type=template&id=1248bc16&scoped=true"
import script from "./AmbassadorsCard.vue?vue&type=script&lang=js"
export * from "./AmbassadorsCard.vue?vue&type=script&lang=js"
import style0 from "./AmbassadorsCard.vue?vue&type=style&index=0&id=1248bc16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248bc16",
  null
  
)

export default component.exports